import Autocomplete from "@mui/material/Autocomplete";
import Chip from "@mui/material/Chip";
import TextField from "@mui/material/TextField";
import { useT } from "../../shared/i18n";

/**
 * Free-form multi-tag autocomplete for the container form (ticket 24):
 * existing and recent tags as options, case-normalized on save.
 */
export function TagAutocomplete({
  options,
  value,
  onChange,
}: {
  options: string[];
  value: string[];
  onChange: (tags: string[]) => void;
}) {
  const t = useT();
  return (
    <Autocomplete
      multiple
      freeSolo
      options={options}
      value={value}
      onChange={(_e, next) => onChange(next)}
      renderTags={(selected, getTagProps) =>
        selected.map((option, index) => <Chip label={option} {...getTagProps({ index })} />)
      }
      renderInput={(params) => (
        <TextField {...params} label={t("formTags")} helperText={t("tagsHint")} />
      )}
    />
  );
}